import { ProductClient as BaseProductClient } from '@jbhi-fi/apis/src/algolia/ProductClient';
import { baseConfig } from '../../config/algolia';
import { serviceHelper } from '../../config/service-helper';

export class ProductClient extends BaseProductClient {
  constructor(overrides: Partial<ConstructorParameters<typeof BaseProductClient>[0]> = {}) {
    const recommendationsEndpoint = serviceHelper.googleRecommendationEndpoint;
    const { shouldExcludeMarketplaceProductsFromSuggestions } = window.Jbhifi?.marketplaceSettings ?? {};

    super({
      shopifyProductsGqlUrl: serviceHelper.shopifyProductsGraphQlPath ?? '',
      shopifyProductsGqlToken: serviceHelper.shopifyProductsGraphQlToken ?? '',
      algoliaSearchIndex: baseConfig.product_families_index ?? '',
      algoliaSearchApiKey: baseConfig.product_families_api_key ?? '',
      algoliaAppId: baseConfig.app_id ?? '',
      recommendationsEndpoint,
      shouldExcludeMarketplaceProductsFromSuggestions,
      ...overrides,
    });
  }
}

export class ProductClientNonFamily extends ProductClient {
  constructor(overrides: Partial<ConstructorParameters<typeof BaseProductClient>[0]> = {}) {
    super({
      algoliaSearchIndex: baseConfig.index_products ?? '',
      ...overrides,
    });
  }
}
